export const INDIVIDUAL_CENTER_IOS = 'individualCenter';

export const WARRANTY_CARD_IOS = 'warrantyCard';

export const INDIVIDUAL_CENTER_ANDROID = '/UserModule/AccountMgtActivity';

export const WARRANTY_CARD_ANDROID = '/UserModule/WarrantyCardActivity';

export const APP_SCHEMA = 'ecoflowapp://';

export const THIRD_DEVICE_VIEW_IOS = 'EFThirdPartyBindResultVC';

export const THIRD_DEVICE_VIEW_ANDROID = '/UserModule/ThirdPlatformLinkSuccessActivity';
